const TephraErrors = require("./errors");
const prettier = require("prettier/standalone");
const babelPlugins = [require("prettier/parser-babylon")];
const prettyJS = val => {
  return prettier.format(val, {
    printWidth: 99999,
    parser: "babel",
    plugins: babelPlugins
  });
};
export default function convertStringToObject(match, _line) {
  let options = "";
  if (match.groups) {
    options = match.groups.options;
  }
  if (typeof options !== "string") return null;
  options = options.trim("");
  let finalObject = null;
  if (!options.startsWith("{") && options.endsWith("}")) return null;
  try {
    finalObject = eval(`Object(${options})`);
    const optionsJSONString = JSON.stringify(finalObject);
    finalObject = JSON.parse(optionsJSONString);
  } catch (error) {
    try {
      finalObject = { __string: prettyJS(`a=${options}`).replace(/(a = )|(;\n)/g, "") };
    } catch (error) {
      const errMsg = TephraErrors.invalidOptionsError(_line, match);
      console.error(errMsg, "original Error: ->", error);
      throw new Error(errMsg);
    }
  }
  return finalObject;
}
